<mat-card class="login-card" fxLayoutAlign="center center">
  <mat-card-content fxFlex.xs="100%" fxFlex="70%" fxLayout="column">
    <img
      fxLayoutAlign="center"
      class="pb-2 logo"
      src="/assets/image/VEIL_Logo_gray_tight.png"
      alt="VEIL logo"
    />
    <form #loginForm="ngForm" class="example-form" fxLayout="column">
      <mat-form-field fxFlex.xs="100%" fxFlex="70%">
        <input
          matInput
          type="email"
          placeholder="Email Address"
          [(ngModel)]="model.email"
          #email="ngModel"
          name="email"
          email
          required
          cdk
        />
        <mat-error *ngIf="email.invalid && (email.touched || email.dirty)">
          <div *ngIf="email.errors.email && !email.errors.required">
            Enter a valid email address
          </div>
          <div *ngIf="email.errors.required">
            Email is required
          </div>
        </mat-error>
      </mat-form-field>
      <mat-form-field fxFlex.xs="100%" fxFlex="70%">
        <input matInput placeholder="Password" [(ngModel)]="model.password" name="password" type="password" required />
      </mat-form-field>
      <mat-card-actions fxLayoutAlign="center">
        <button
          mat-raised-button
          [disabled]="!loginForm.form.valid"
          type="submit"
          (click)="login()"
          color="primary"
          fxFlex="95%"
        >
          Log In
        </button>
      </mat-card-actions>
    </form>
    <div id="link-actions" fxLayout.xs="column" fxLayout="row" fxLayoutAlign="center">
      <a mat-button color="primary" routerLink="/forgot-password">Forgot Password?</a>
      <!--<a fxFlex.xs="95%" fxFlex="50%" mat-button routerLink="/forgot-password">Forgot Password?</a>-->
      <!--<a fxFlex.xs="95%" fxFlex="50%" mat-button routerLink="/select-app">Sign Up</a>-->
    </div>
  </mat-card-content>
</mat-card>
